export const selectUserName = (state: any) => state?.user?.name;
export const selectUserEmail = (state: any) => state.user.email;
export const selectUserPhoto = (state: any) => state?.user?.photo;
